import _ from 'lodash';

export const getRouteClaimId = () => {
    return getClaimIdHref() || getClaimIdState();
};

export const getClaimIdHref = (): string | undefined => {
    const claimIdRegex = RegExp(/claims\/([\w-]+)/gi);

    const match = claimIdRegex.exec(window.location.href);

    return match ? match[1] : undefined;
};

export const getClaimIdState = (): string | undefined => {
    return _.get(history, 'location.state.claimId');
};
